import React from 'react';
import PropTypes from 'prop-types';
import YesNoModalComponent from 'shared/components/yes-no-modal/YesNoModalComponent';

const HEADER = 'Switch Organisation';
const DESCRIPTION =
  'Switching organisation will reload the app, and all unsaved work will be lost. Continue?';

function SwitchOrganisationModal({ show, isLoading, onConfirm, onCancel }) {
  return (
    <YesNoModalComponent
      closeModal={onCancel}
      confirmModal={onConfirm}
      description={DESCRIPTION}
      header={HEADER}
      isLoading={isLoading}
      noButtonText="Cancel"
      showModal={show}
      yesButtonText="Continue"
    />
  );
}

SwitchOrganisationModal.propTypes = {
  show: PropTypes.bool,
  isLoading: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

SwitchOrganisationModal.defaultProps = {
  show: false,
  isLoading: false,
};

export default SwitchOrganisationModal;
